<app-toast></app-toast>
@if (pageLoaderService.isLoading() && !isDocumentUploadRoute() || pageLoaderService.isSubmitting())
{
<div class="full-page-loader">
  <app-card-loader></app-card-loader>
</div>
}
<div class="app-container">
  <app-header (themeChange)="onThemeChange($event)"></app-header>
  <div class="app-layout">
    @if (showSideMenu() && !pageLoaderService.isDocumentUploadLoading()) {
    <app-side-menu></app-side-menu>
    } @if (pageLoaderService.isDocumentUploadLoading()) {
    <div class="sidenav-skeleton"></div>
    <div class="bottomnav-skeleton"></div>
    }
    <main
      class="app-content"
      [class.dg-05-background]="pageLoaderService.isDocumentUploadLoading()"
      [style.justify-content]="
        pageLoaderService.isDocumentUploadLoading() ? 'flex-start' : 'center'
      "
    >
      @if (pageLoaderService.isDocumentUploadLoading()) {
      <div class="documentupload-skeleton-content">
        <!-- <div class="documentupload-skeleton-header"></div> -->
        <div class="documentupload-loader-card">
          <app-card-loader [width]="'120px'"></app-card-loader>
        </div>
        <div class="documentupload-loader-card">
          <app-card-loader [width]="'120px'"></app-card-loader>
        </div>
        <div class="documentupload-loader-card">
          <app-card-loader [width]="'120px'"></app-card-loader>
        </div>
        @if (isSnlRoute()) {
        <div class="documentupload-loader-card">
          <app-card-loader [width]="'120px'"></app-card-loader>
        </div>
        }
      </div>
      } @else {
      <router-outlet></router-outlet>
      }
    </main>
  </div>
</div>
